import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

//constants

//validators
import { dropDownValidator }                from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator }                from '../../validators/CustomValidators';

import * as ent from '../../entities/index'

//components
import {EquipmentLineItemGridComponent} from '../../components/Grids/EquipmentLineItemGrid.component';

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseControlGroupComponent }         from '../../baseclasses/BaseControlGroup.component';

@Component({
  selector: 'my-equipmentdetails',
  templateUrl: './EquipmentDetails.component.html',
  providers: [{provide: BaseControlGroupComponent, useExisting: forwardRef(() => EquipmentDetailsComponent)}]
})
export class EquipmentDetailsComponent extends BaseControlGroupComponent {

    @ViewChild(EquipmentLineItemGridComponent) public equipmentLineItemGrid: EquipmentLineItemGridComponent;
    
    equipmentDetailsForm: FormGroup;
  
    @Input() public requireEquipmentGraphics: boolean;
    @Input() public requireEquipmentAssetNumber: boolean;
    @Input() public requireSerialNumber: boolean;
    @Input() public requireModel: boolean;
    @Input() public requireLocation: boolean;
    @Input() public requireCurrentLocation: boolean;
    @Input() public requireMoveToLocation: boolean;
    @Input() public requireNewCustomerNumber: boolean;
    
    @Input() public showEquipmentGraphics: boolean;
    @Input() public showEquipmentAssetNumber: boolean;
    @Input() public showSerialNumber: boolean;
    @Input() public showMaterialNumber: boolean;
    @Input() public showModel: boolean;
    @Input() public showEquipmentClass: boolean;
    @Input() public showProcessedByRequest: boolean;
    @Input() public showLocation: boolean;
    @Input() public showCurrentLocation: boolean;
    @Input() public showMoveToLocation: boolean;
    @Input() public showNewCustomerNumber: boolean;

    @Input() showCheckboxSelectorColumn: boolean;
    @Input() showRadioSelectorColumn: boolean;

    @Output() equipmentLineItemsChanged: EventEmitter<ent.EquipmentLineItem[]> = new EventEmitter();

    setDates(){}

    setRequestInfo(request: ent.Request){
        this.equipmentLineItemGrid.lineItems = request.EquipmentLineItems;
        this.equipmentLineItemGrid.requestID = request.ID;
    }

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
          
        };
        
        this.equipmentDetailsForm = fb.group(group);

    }


    ngOnInit(): void {
    }

    onEquipmentLineItemsChanged(lineItems: ent.EquipmentLineItem[]){
        this.equipmentLineItemsChanged.emit(lineItems);
    }


}